
import { Component, ElementRef, Input, OnDestroy } from '@angular/core';
import { SiriusBaseComponent } from 'sirius-framework';
import { CommonService } from '../../shared/service/shared.service';
import { SiteLanguageService } from '../../shared/service/site-language.service';
import { Subscription } from 'rxjs';
//import { SiriusDialogAction } from '@ibtech/sirius-angular-dialog'
import { KvkkPopupModel } from './kvkkPopup.model';
import { DomSanitizer } from '@angular/platform-browser';

declare const $: any;

/** String resource — boşsa Türkçe varsayılan */
const KVKK_POPUP_KEYS = {
    btnTamam: 'yediEminKvkkPopupBtnTamam',
    closeLabel: 'yediEminKvkkPopupCloseLabel',
};

@Component({
    selector: 'kvkk-popup',
    templateUrl: './kvkkPopup.component.html',
    styleUrls: ['./kvkkPopup.component.css'],
})

export class KvkkPopupComponent extends SiriusBaseComponent<KvkkPopupModel> implements OnDestroy {
    kvkkMessage: any;
    kvkkTitle: any;
    btnTamam = 'Tamam';
    closeLabel = 'X';
    public isOpen: boolean = false;
    public closeEvent: any;
    @Input() kvkkTextIn: string;
    @Input() kvkkTitleIn: string;

    private langSub: Subscription;

    constructor(
        private el: ElementRef,
        private domSanitizer: DomSanitizer,
        private commonService: CommonService,
        private siteLanguageService: SiteLanguageService,
    ) {
        super();
        this.langSub = this.siteLanguageService.languageCode$.subscribe(() => {
            if (this.isOpen) {
                this.loadKvkkPopupResourceStrings();
            }
        });
    }

    OnInit() {
        this.loadKvkkPopupResourceStrings();
    }

    ngOnDestroy() {
        if (this.langSub) {
            this.langSub.unsubscribe();
        }
    }

    private loadKvkkPopupResourceStrings(): void {
        const r = (key: string, fallback: string) => this.commonService.getStringResource(key, fallback);
        this.btnTamam = r(KVKK_POPUP_KEYS.btnTamam, this.btnTamam);
        this.closeLabel = r(KVKK_POPUP_KEYS.closeLabel, this.closeLabel);
    }

   // public onActionClick(e: SiriusDialogAction) {
  //TODO:
  public onActionClick( ) {

        //if (e.commandName == 'ok') {
        //    this.isOpen = false;
        //}
    }

    //close popup
    public close() {
        this.isOpen = false;
        $('html').removeClass('dont-move-back');
        if (this.closeEvent) {
            this.closeEvent();
        }
    }

    public open(title: any, content: any) {
        this.loadKvkkPopupResourceStrings();
        this.kvkkTitle = title;
        this.kvkkMessage = this.domSanitizer.bypassSecurityTrustHtml(content);
        $('html').addClass('dont-move-back');
        this.isOpen = true;
    }

    public setTitleAndMessage(title: string, message: string) {
        this.loadKvkkPopupResourceStrings();
        this.kvkkTitle = title;
        this.kvkkMessage = this.domSanitizer.bypassSecurityTrustHtml(message);
    }
}
